import React from 'react';
import { Button } from '@mui/material';
import { useAuth } from '../../hooks/useAuth';

interface LoginButtonProps {
  variant?: 'text' | 'outlined' | 'contained';
  color?: 'inherit' | 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning';
  fullWidth?: boolean;
  forceClean?: boolean;
}

export const LoginButton: React.FC<LoginButtonProps> = ({
  variant = 'contained',
  color = 'primary',
  fullWidth = false,
  forceClean = false,
}) => {
  const { login } = useAuth();

  return (
    <Button
      variant={variant}
      color={color}
      fullWidth={fullWidth}
      onClick={() => login(forceClean)}
    >
      Log In
    </Button>
  );
};